import type { CSSProperties, ReactNode } from 'react';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface CstretchmodalFooterProps {
    dataElScope: DataElScope;
    floatingFooter: boolean;
    footer: ReactNode;
    style: CSSProperties;
}
export function CstretchmodalFooter({ dataElScope, floatingFooter, footer, style, }: CstretchmodalFooterProps): ReactNode {
    if (!footer) {
        return footer;
    }
    if (floatingFooter) {
        return false;
    }
    return (
      <div data-el={dataEl(dataElScope, 'Footer/Root')} style={style}>
        {footer}
      </div>
    );
}
